export default __webpack_public_path__ + "static/media/Foyer.3a036205.jpg";